import Cookies from 'js-cookie';

export function getCurrentServiceId() {
	return +Cookies.get('currentServiceId') || 1;
}

export function saveCurrentServiceId(currentServiceId: number) {
	Cookies.set('currentServiceId', `${currentServiceId}`);
}
